const digest = '950e57f0d11a647e7da6e893db11af9a03582a693eb0e3c1b4a8578f20464290';
const css = `._waitListButton_9g2fz_1{background-color:#006fcf;text-decoration:none}._waitListButton_9g2fz_1:hover{background-color:#0062b6;border-color:#0062b6}._waitListButton_9g2fz_1:active{text-decoration:none}._alertDialogBody_9g2fz_13 [role=alertdialog]>div:nth-of-type(3){border-top:0;margin-top:0;padding-top:0}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'waitListButton': '_waitListButton_9g2fz_1', 'alertDialogBody': '_alertDialogBody_9g2fz_13' };
export const waitListButton = '_waitListButton_9g2fz_1';
export const alertDialogBody = '_alertDialogBody_9g2fz_13';
export { css, digest };